// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export const El = new Map();
export const Oo = [];
export let ko = 0;
export const R2 = 3;
export const B2 = 48;
export function cardArtUrls(u) {
  return [...new Set([u.thumbnailPath, u.mediaPath])].filter(o => !!o && !/\.(mp4|webm)(\?|$)/i.test(o)).map(o => `/${o.replace(/^\/+/, "")}`);
}
export function drainArtQueue() {
  for (; ko < R2 && Oo.length;) ko += 1, Oo.shift()();
}
export function loadCardImage(u) {
  return new Promise(o => {
    const m = new Image();
    m.decoding = "async";
    let r = !1;
    const g = B => {
        r || (r = !0, window.clearTimeout(j), m.onload = null, m.onerror = null, o(B));
      },
      j = window.setTimeout(() => {
        m.src = "", g(!1);
      }, 6e3);
    m.onload = () => {
      m.decode().catch(() => {}).then(() => g(!0));
    }, m.onerror = () => g(!1), m.src = u;
  });
}
export function preloadCardArt(u) {
  const o = cardArtUrls(u);
  if (!o.length) return Promise.resolve(null);
  const m = o.join("|"),
    r = El.get(m);
  if (r) return r;
  const g = new Promise(j => {
    Oo.push(() => {
      (async () => {
        for (const B of o) if (await loadCardImage(B)) return B;
        return null;
      })().then(j).finally(() => {
        ko -= 1, drainArtQueue();
      });
    });
  });
  return El.set(m, g), El.size > B2 && El.delete(El.keys().next().value), g.then(j => {
    !j && El.get(m) === g && El.delete(m);
  }), drainArtQueue(), g;
}
export function preloadNextCards(u) {
  u.slice(0, 4).forEach(o => {
    preloadCardArt(o);
  });
}
